export const CATEGORY_TABS_LIST = [
  {
    value: "AIR SYSTEM",
    label: "AIR SYSTEM",
  },
  {
    value: "Fuel System",
    label: "Fuel System",
  },
  {
    value: "Lube System",
    label: "Lube System",
  },
  {
    value: "Coolant Condition",
    label: "Coolant Condition",
  },
  {
    value: "Electrical System",
    label: "Electrical System",
  },
];
